"use strict";
/**
 * DataEditTabs
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var commonTypes_1 = require("../../shared/types/commonTypes");
var styles_1 = require("@mui/styles");
var LabelWithTooltipComponent_1 = __importDefault(require("../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    tabs: {
        backgroundColor: theme.palette.grey.A100,
        borderLeft: "2px solid " + theme.palette.grey.A100,
        borderRight: "2px solid " + theme.palette.grey.A100,
        borderRadius: '4px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.secondary.main,
            top: 0,
            bottom: 'inherit',
        },
        '& .Mui-selected': {
            backgroundColor: theme.palette.background.paper,
        },
    },
}); });
var DataEditTabs = function (props) {
    var t = react_i18next_1.useTranslation().t;
    var entity = props.entity;
    var classes = useStyles();
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var entityEditLayout = props.entityEditLayout;
    var _a = react_1.useState(props.initialTab), selectedTabIndex = _a[0], setSelectedTabIndex = _a[1];
    var getEditViewTabs = function () {
        var _a;
        var calculatedTabIndex = 0;
        var subTabs = [];
        var initialEditTabs = [];
        // zunächst prüfen, ob eine Config zu den Tabs genutzt wird
        if ((_a = props.entityEditLayout) === null || _a === void 0 ? void 0 : _a.editTabs) {
            var tmpEditTabs = __spreadArrays(props.entityEditLayout.editTabs);
            tmpEditTabs.map(function (editTab) {
                initialEditTabs.push({
                    key: calculatedTabIndex,
                    hideTab: false,
                    label: editTab.title ? editTab.title[crudeLanguage] : editTab.name,
                    description: editTab.description && editTab.description[crudeLanguage],
                });
                calculatedTabIndex += 1;
            });
        }
        else {
            initialEditTabs.push({
                key: calculatedTabIndex,
                hideTab: false,
                label: t('crude:tabDetail'),
            });
            calculatedTabIndex += 1;
        }
        // default werden alle incomingReferences als Tabs angefügt, ansonsten nur die, die noch nicht verwendet wurden
        // zuerst werden alle Tabs aus der config, wenn im Schema vorhanden genutzt (Reihenfolge beachten)
        if (crudeConfig.tabs) {
            crudeConfig.tabs.forEach(function (tab) {
                if (tab.entity === props.entity) {
                    subTabs = tab.tabs || [];
                    tab.tabs && tab.tabs.forEach(function (subTab) {
                        // Prüfung, ob dieser Tab in den incomingReferences der Entity enthalten ist und ggf. verwenden
                        entitySchema && entitySchema.incomingReferences.forEach(function (incomingReferences) {
                            var _a, _b;
                            if (incomingReferences.sourceEntity === subTab.sourceEntity && incomingReferences.sourceColumn === subTab.sourceColumn && !subTab.hideEntity) {
                                var label = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[subTab.sourceEntity]) === null || _b === void 0 ? void 0 : _b.title;
                                initialEditTabs.push({
                                    key: calculatedTabIndex,
                                    description: subTab.description && subTab.description[crudeLanguage],
                                    sourceEntity: subTab.sourceEntity,
                                    sourceColumn: subTab.sourceColumn,
                                    hideTab: subTab.hideEntity || false,
                                    label: (subTab.label && subTab.label[crudeLanguage]) || label || subTab.sourceEntity,
                                });
                                calculatedTabIndex += 1;
                            }
                        });
                    });
                }
            });
        }
        // hier noch die anderen anfügen, sofern sie nicht hidden sind oder schon verwendet wurden > TODO Verwendung noch prüfen
        if (entitySchema && entitySchema.incomingReferences) {
            var incomingReferences = entitySchema.incomingReferences;
            incomingReferences.map(function (entityReference) {
                var _a, _b, _c, _d, _e, _f;
                // prüfen, ob subTab in der config schon verwendet wurde
                var subTab = subTabs && subTabs.find(function (configSubTab) { return configSubTab.sourceEntity === entityReference.sourceEntity && configSubTab.sourceColumn === entityReference.sourceColumn; });
                var existingIncomingReference = false;
                // prüfen, ob die reference schon innerhalb eines Tabs verwendet wurde
                entityEditLayout === null || entityEditLayout === void 0 ? void 0 : entityEditLayout.elements.map(function (element) {
                    if (element.name === 'crudeIncomingReference') {
                        if (element.sourceColumn === entityReference.sourceColumn && element.sourceEntity === entityReference.sourceEntity) {
                            existingIncomingReference = true;
                        }
                    }
                });
                // wenn es noch nicht verwendet wurde, dann bitte noch anfügen
                if (!subTab && !existingIncomingReference) {
                    var sourceSchema = crudeSchema && crudeSchema.find(function (sourceSchema) { return (sourceSchema.name === entityReference.sourceEntity); });
                    var entity_1 = sourceSchema ? sourceSchema.name : entityReference.sourceEntity;
                    if (entityReference.manyToManyOppositeEntityName) {
                        entity_1 = entityReference.manyToManyOppositeEntityName;
                    }
                    var label = (_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[entity_1]) === null || _b === void 0 ? void 0 : _b.title;
                    var description = (_d = (_c = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _c === void 0 ? void 0 : _c.entity[entity_1]) === null || _d === void 0 ? void 0 : _d.description;
                    if (entityReference.targetEntity) {
                        var targetEntityLabels = (_f = (_e = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _e === void 0 ? void 0 : _e.entity[entityReference.targetEntity]) === null || _f === void 0 ? void 0 : _f.references;
                        label = targetEntityLabels && targetEntityLabels[entityReference.sourceEntity] ? targetEntityLabels[entityReference.sourceEntity][entityReference.sourceColumn] : label;
                    }
                    initialEditTabs.push({
                        key: calculatedTabIndex,
                        label: label || entity_1,
                        description: description,
                        hideTab: false,
                        sourceEntity: entityReference.sourceEntity,
                        sourceColumn: entityReference.sourceColumn,
                    });
                    calculatedTabIndex += 1;
                }
            });
        }
        setEditTabs(initialEditTabs);
        initialEditTabs && props.setEditTabs(initialEditTabs);
    };
    var _b = react_1.useState([]), editTabs = _b[0], setEditTabs = _b[1];
    var _c = react_1.useState(), firstDropdownIndex = _c[0], setFirstDropdownIndex = _c[1];
    var _d = react_1.useState(false), openTabPopOver = _d[0], setOpenTabPopOver = _d[1];
    var _e = react_1.useState(), anchorEl = _e[0], setAnchorEl = _e[1];
    react_1.useEffect(function () {
        var _a;
        setFirstDropdownIndex(undefined);
        var firstIndex;
        var completeSubTabsWidth = ((_a = window.document.getElementById("subTabs_" + selectedTabIndex)) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        var singleSubTabWidth = 0;
        editTabs.map(function (tab, index) {
            var _a;
            if (!tab.hideTab) {
                singleSubTabWidth += ((_a = window.document.getElementById("subTab_" + index)) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
                if (singleSubTabWidth >= completeSubTabsWidth && firstIndex === undefined) {
                    firstIndex = index;
                }
            }
        });
        setFirstDropdownIndex(firstIndex);
    }, [window.document.getElementById("subTabs_" + selectedTabIndex)]);
    react_1.useEffect(function () {
        props.dataViewType === commonTypes_1.DataViewType.fullView && getEditViewTabs();
    }, [crudeLabels]);
    return (react_1.default.createElement(react_1.default.Fragment, null, editTabs.length > 0 &&
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Tabs, { id: "subTabs_" + selectedTabIndex, variant: screenDesign === commonTypes_1.ScreenDesign.mobile ? 'standard' : 'scrollable', value: selectedTabIndex, className: classes.tabs, sx: { mb: 2 } },
                editTabs.map(function (tab, index) {
                    if (!tab.hideTab && ((firstDropdownIndex && index < firstDropdownIndex) || !firstDropdownIndex)) {
                        return (react_1.default.createElement(material_1.Tab, { id: "subTab_" + index, sx: { flexDirection: 'row-reverse' }, onClick: function () {
                                setSelectedTabIndex(index);
                                props.changeEditTab && props.changeEditTab(tab.key);
                            }, key: tab.key, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: tab.label, description: tab.description }) }));
                    }
                }),
                firstDropdownIndex &&
                    react_1.default.createElement(material_1.Tab, { sx: { flexDirection: 'row-reverse' }, icon: react_1.default.createElement(ArrowDropDown_1.default, { onClick: function (current) {
                                setAnchorEl(current.target);
                                setOpenTabPopOver(true);
                            } }) })),
            react_1.default.createElement(material_1.Popover, { anchorEl: anchorEl, open: openTabPopOver, onClose: function () { return setOpenTabPopOver(false); }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, firstDropdownIndex && editTabs.map(function (tab, index) {
                if (!tab.hideTab && index >= firstDropdownIndex) {
                    return (react_1.default.createElement(material_1.MenuItem, { onClick: function () {
                            setOpenTabPopOver(false);
                            setSelectedTabIndex(index);
                            props.changeEditTab && props.changeEditTab(tab.key);
                        } },
                        react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: tab.label, description: tab.description })));
                }
            })))));
};
exports.default = DataEditTabs;
